import {Contacts} from './Contacts';
import {OnboardingWorkspaceOverview} from './OnboardingWorkspaceOverview';
import {CommunicationsWorkspaceOverview} from './CommunicationsWorkspaceOverview';
import {Permissions as P,type Permission} from '@myfm/domain';
import {useWorkspaceSession} from '../ui/StaffSession';
import {Enquiries} from './Enquiries';
import {WorkCases} from './WorkCases';
import {SupplierRegister} from './SupplierSetup';
import {InsurancePolicyRegister} from './InsurancePolicies';
import {PortfolioRecordOverview} from './PortfolioRecordOverview';
import {WorkforceOverview} from './WorkforceOverview';
const permissions:Record<string,readonly Permission[]>={
 finance:[P.ViewFinance],operations_compliance:[P.ViewCompliance],property_admin:[P.ViewMaster],
 onboarding:[P.ViewMaster,P.ViewClientOnboarding],
 communications:[P.ViewCommunications],
 governance:[P.ViewGovernance,P.ViewPropertyLegal,P.ViewWork],
 new_business:[P.ViewEnquiries],
 repairs:[P.ViewWork],
 suppliers:[P.ViewMaster],
 insurance:[P.ViewInsurance],
 assets:[P.ViewMaster],
 people:[P.ViewWorkforce]};
export function hasWorkspaceRegisterOverview(code:string,capabilities:readonly Permission[]){return Boolean(permissions[code]&&permissions[code]!.every(permission=>capabilities.includes(permission)));}
export function WorkspaceRegisterOverview({code}:{code:string}){
 const session=useWorkspaceSession()!,building=session.effectiveScope.kind==='building'?session.effectiveScope.id:undefined;if(!hasWorkspaceRegisterOverview(code,session.capabilities)||['finance','operations_compliance'].includes(code))return null;
 return <section className="workspace-register-overview" aria-label="Source-backed workspace overview">
{code==='property_admin'?<Contacts embedded/>:
 code==='onboarding'?<OnboardingWorkspaceOverview building={building}/>:
 code==='communications'?<CommunicationsWorkspaceOverview building={building}/>:
 code==='governance'?<PortfolioRecordOverview kind="governance"/>:
 code==='new_business'?<><p className="workspace-source-note">The enquiry pipeline is organisation-wide. A selected building does not limit unappointed new-business enquiries.</p>
<Enquiries embedded/>
</>:
 code==='repairs'?<WorkCases embedded/>:
 code==='suppliers'?<SupplierRegister embedded/>:
 code==='insurance'?<InsurancePolicyRegister embedded/>:
 code==='assets'?<PortfolioRecordOverview kind="assets"/>:
 code==='people'?<WorkforceOverview/>:null}</section>;
}
